module.exports = __webpack_public_path__ + "static/media/YOGI-QEMPO2.e6966461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/YOGI-QEMPO2.png
// module id = 194
// module chunks = 0